import { useMutation, useQueryClient } from 'react-query';
import { apiCpService } from '@services/apiCpService.ts';
import { FindRunningChargePointsQueryKey } from '@services/queries/use-find-running-charge-points.query.ts';

export const CreateClientMutationKey = 'create-client';

interface CreateClientData {
  host: string;
  cpid: string;
  basicAuth?: string;
  vendor?: string;
  model?: string;
}

export const useCreateClientMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    CreateClientMutationKey,
    async ({ cpid, host, basicAuth, vendor, model }: CreateClientData) => {
      await apiCpService.createClientCpClientCpidPut(cpid, { host, basic_auth_pw: basicAuth, vendor, model });
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(FindRunningChargePointsQueryKey);
      },
    },
  );
};
